export abstract class EbenGenericError {
  public timestamp: Date;
  protected constructor() {
    this.timestamp = new Date();
  }
}
